<template>
  <div>
    <div class="compositionCom">
      <div class="list">
        <dl>
          <dt>構成可能メンバー <i class="UXicon-person"></i><strong><span>{{ agentSize }}</span>名</strong></dt>
          <dd>
            <div class="searchInput">
              <v-text-field
                      v-model="search"
                      placeholder="メンバー名またはIDで検索"
                      @keyup="onSearch(search, 'agents', 'member')"
                      @click:clear="search = '';onSearch(search, 'agents', 'member');"
                      :disabled="disabled"
                      class="UXinput UXicon-search"
                      hide-details
                      clearable
                      outline
                      solo
              ></v-text-field>
            </div>
            <ul v-if="agents.length !== 0">
              <li v-for="(item, index) in agents" :key="index">
                <strong>{{ item.name }}</strong>
                <p>{{ item.loginId }}</p>
                <v-btn icon @click="addMember(item, index)" :disabled="disabled">
                  <i class="UXicon-add_circle" />
                </v-btn>
              </li>
            </ul>
            <div class="notAgent" v-if="agents.length === 0">
              <span v-if="search">検索したメンバーがいません。</span>
              <span v-else>構成可能なメンバーがいません。</span>
            </div>
          </dd>
        </dl>
      </div>
      <div class="list">
        <dl>
          <dt>構成メンバー <i class="UXicon-person"></i><strong><span>{{ memberSize }}</span>名</strong></dt>
          <dd>
            <div class="searchInput">
              <v-text-field
                v-model="checkedSearch"
                placeholder="メンバー名またはIDで検索"
                @keyup="onSearch(checkedSearch, 'member', 'agents')"
                @click:clear="checkedSearch = '';onSearch(checkedSearch, 'member', 'agents');"
                class="UXinput UXicon-search"
                hide-details
                clearable
                outline
                solo
              ></v-text-field>
            </div>
            <ul v-if="member.length !== 0">
              <li v-for="(item, index) in member" :key="index">
                <strong>{{ item.name }}</strong>
                <p>{{ item.loginId }}</p>
                <v-btn icon @click="deleteMemberCheck(item)" :disabled="disabled">
                  <i class="UXicon-error" />
                </v-btn>
              </li>
            </ul>
            <div class="notAgent" v-if="member.length === 0">
              <span v-if="checkedSearch">検索したメンバーがいません。</span>
              <span v-else>登録されたメンバーがいません。<br />メンバーを追加してください。</span>
            </div>
          </dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'role-member-transfer',
  props: {
    groupId: {
      type: Number,
      required: false,
      default: null
    },
    disabled: {
      type: Boolean,
      required: false
    },
    groupName: {
      type: String,
      require: false,
      default: ''
    },
    brandId: {
      type: Number,
      require: false
    },
    dialog: {
      type: Boolean,
      require: false
    }
  },
  data () {
    return {
      search: '',
      checkedSearch: '',
      agentSize: 0,
      memberSize: 0,
      allAgents: [],
      member: [],
      storeMember: [],
      agents: [],
      choiceId: null,
      isAdmin: false
    }
  },
  computed: {
    ...mapGetters(['currentBrandId', 'currentParentBrandId'])
  },
  mounted () {
    if (this.$route.name === 'admin_management_role_new' || this.$route.name === 'admin_management_role_modify') {
      this.isAdmin = true
      this.init()
    }
    this.$eventBus.$on('brand-loading-complete', () => {
      this.init()
    })
  },
  methods: {
    init () {
      this.search = ''
      this.checkedSearch = ''
      if (this.isAdmin) {
        if (!this.currentParentBrandId && !this.$route.query.brandId) {
          this.$router.push('/admin/management/role')
        }
        this.choiceId = this.currentParentBrandId || this.$route.query.brandId
      } else {
        this.choiceId = this.brandId || this.currentBrandId
      }

      if (this.choiceId) {
        this.agents = []
        this.storeMember = []
        this.getRoleAgents()
      }
    },
    setGroupIds () {
      let agentIds = []
      this.storeMember.map(item => {
        if (item.id) agentIds.push(item.id)
      })
      this.$emit('set-group-ids', agentIds)
    },
    getRoleAgents () {
      if (this.choiceId && this.groupId) {
        this.$http
          .get(`/api/brand/${this.choiceId}/permissionGroups/${this.groupId}`)
          .then((result) => {
            let raw = result.data
            if (raw.code === 0) {
              this.member = this.doSort(raw.data.agents) || []
              if (this.storeMember.length === 0) {
                this.storeMember = []
                raw.data.agents.map((item) => {
                  this.storeMember.push(item)
                })
                this.memberSize = this.member.length
                this.agentSort('storeMember')
                this.getAllAgents()
              }
            } else {
              this.$toasted.error(raw.message)
            }
          })
      } else {
        this.getAllAgents()
      }
    },
    getAllAgents () {
      const callUrl = (this.choiceId && this.groupName) ? `/api/brand/${this.choiceId}/v3/agents?brandPermissionGroupName=${encodeURI(this.groupName)}` : `/api/brand/${this.choiceId}/v3/agents`
      this.$http
        .get(callUrl)
        .then((result) => {
          let raw = result.data
          if (raw.code === 0) {
            this.allAgents = this.doSort(raw.data)
            if (this.agents.length === 0) {
              raw.data.map((item) => {
                this.agents.push(item)
              })
              this.agentSort('agents')
              this.agentSize = this.agents.length - this.member.length
              if (this.member.length > 0) {
                this.agents = this.filterAgents('member')
              }
            }
          } else {
            this.$toasted.error(raw.message)
          }
        })
    },
    getMembers (item) {
      this.agentId = item.id
      this.$http.get(`/api/brand/${this.choiceId}/v2/agents/${this.agentId}`).then(result => {
        let raw = result.data
        if (raw.code === 0) {
          let checkedCount = 0
          this.memberData = raw.data
          this.memberData.permissionGroups.forEach((elm) => {
            if (elm.checked || elm.id === this.groupId) {
              checkedCount++
            }
          })
          if (checkedCount < 2) {
            this.$alertMsg('最後の権限は削除できません。')
            return false
          }
          this.deleteMember(item)
        } else {
          this.$toasted.error(raw.message)
        }
      })
    },
    addMember (item, index) {
      if (!this.checkedSearch) {
        this.member.push(item)
        this.agentSort('member')
      }
      this.agentSize = this.agentSize - 1
      this.memberSize = this.memberSize + 1
      this.storeMember.push(item)
      this.agentSort('storeMember')
      this.agents.splice(index, 1)
      this.$set(this, 'agents', this.agents.filter(d => d.id !== item.id))
    },
    deleteMember (item) {
      this.agentSize = this.agentSize + 1
      this.memberSize = this.memberSize - 1
      this.agents.push(item)
      this.agentSort('agents')
      this.member = this.member.filter(d => d.id !== item.id)
      this.storeMember = this.storeMember.filter(d => d.id !== item.id)
      this.$set(this, 'member', this.storeMember.filter(d => d.id !== item.id))
    },
    deleteMemberCheck (item) {
      this.getMembers(item)
    },
    doSort (target) {
      return target.sort((a, b) => {
        return a.name < b.name ? -1 : a.name > b.name ? 1 : 0
      })
    },
    agentSort (name) {
      this[name].sort((a, b) => {
        return a.name < b.name ? -1 : a.name > b.name ? 1 : 0
      })
    },
    filterAgents (checkName) {
      if (checkName === 'agents') {
        return this.storeMember.map(item => item)
      } else {
        let tempArray = this.allAgents
        for (let j = 0; j < this.storeMember.length; j++) {
          tempArray = tempArray.filter(item => item.loginId !== this.storeMember[j].loginId)
        }
        return tempArray
      }
    },
    onSearch (inpValue, listName, checkName) {
      if (inpValue) {
        this[listName] = this.filterAgents(checkName).filter(item => {
          return item.name.indexOf(inpValue) > -1 || item.loginId.indexOf(inpValue) > -1
        })
      } else {
        this[listName] = this.filterAgents(checkName)
      }
    },
    reset () {
      this.member = []
      this.agents = []
    }
  },
  watch: {
    groupName (newVal, oldVal) {
      if (newVal !== oldVal) this.init()
    },
    dialog (val) {
      if (val === true) {
        this.init()
      } else {
        this.reset()
      }
    },
    storeMember (val) {
      this.$emit('validChange', !!val.length)
    }
  }
}
</script>

<style lang="scss" scoped>
.transferCon {
  width: 700px;

  .UXinput {
    max-width: 225px;
    width: 225px;
  }

  .mbHeader {
    height: 35px;
    margin-bottom: 10px;
    > .left {
      height: 20px;
      font-weight: bold;
      font-size: 14px;
      color: #414141;
      line-height: 35px;
      > span {
        &:first-child { margin-right: 7px; }
        i {
          position: relative;
          top: 2px;
          margin-right: -8px;
          font-size: 18px;
        }

        &:last-child {
          margin-left: 5px;
          > .important { color: #ff8c8c; }
        }
      }
    }

    > .right {
      min-width: 300px;
      height: 35px;
      > span {
        &:first-child {
          width: 85px;
          margin-right: 4px;
          font-size: 14px;
          font-weight: bold;
          color: #414141;
        }
      }
      >>> .v-text-field {
        display: inline-block;
        width: 240px;
        max-width: 240px;
      }
    }
  }

  .mbCon {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    height: 430px;
    overflow: hidden;
    > div {
      margin: 0;
      padding: 0;
      &.transferPan {
        width: 340px;
        height: 100%;
        border: 1px solid #BEBEBE;
        box-sizing: border-box;
        border-radius: 3px;
        overflow-x: hidden;
        overflow-y: auto;
        .noData {
          position: relative;
          top: 50%;
          height: 40px;
          margin-top: -20px;
          vertical-align: middle;
          text-align: center;
          color: #919191;
          line-height: 20px;
        }

        ul {
          width: 100%;
          padding-left: 0;
          > li {
            display: flex;
            width: calc(100% - 20px);
            list-style: none;
            height: 65px;
            border-bottom: 1px solid #E8E8E8;
            padding: 13px 0;
            margin: 0 10px;
            > div { height: 65px; }
            .member {
              width: calc(100% - 24px);
              height: 40px;
              > div {
                height: 20px;
                font-size: 14px;
                &.memberName {
                  font-weight: bold;
                  color: #121212;
                }
                &.memberEmail {
                  color: #919191;
                }
              }
            }
            i {
              line-height: 40px;
              &.UXicon-error { color: #FF7875; }
              &.UXicon-add_circle { color: #ff8c8c; }
            }
          }
        }
      }

      &.transferArrow {
        width: 20px;
        height: 100%;
        line-height: 430px;
        i {
          color: #919191;
          margin: -2px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/management/brand/roleMemberTransfer.vue